
import { Inject } from "vue-property-decorator"
import { Options, Vue } from "vue-class-component"
import draggable from "vuedraggable"

@Options({
  name: "drag-wrapper",
  components: { draggable },
  props: ["modelValue", "attribute"]
})
export default class DragWrapper extends Vue {
  @Inject() config: any
  readonly modelValue: any
  readonly attribute: any = {}
  childrenmenu?: Function

  created() {
    const attribute = this.attribute
    attribute.move = attribute.move || function() {}
  }

  mounted() {
    const { CPKit } = this.config
    const style = this.attribute.style || {}
    CPKit.copy(this.$el.style, style)
  }

  componentData() {
    const { props } = this.attribute
    if (!!props && typeof(props) === "function") {
      return props()
    }
  }

  innerMove(other: number, evt: any) {
    const { move } = this.attribute
    if (!!move && typeof(move) === "function") {
      return move(other, evt)
    }
  }
}
